import React, { useEffect, useState } from "react";
import Translations from "../../services/translation.service";
import Settings from "../../services/settings.service";
import VMLogo from '../../assets/img/VM_logo.svg';
import Tiwiter from '../../assets/img/social/footer_twitter.svg';
import Insta from '../../assets/img/social/footer_insta.svg';
import Facebook from '../../assets/img/social/footer_fb.svg';
import YouTube from '../../assets/img/social/footer_youtube.svg';
// import LinkedIN from '../../assets/img/social/footer_linkedin.svg';
import CallUs from '../../assets/img/social/CallUs.svg';
import LocateUs from '../../assets/img/social/LocateUs.svg';
import Storage from "../../services/storage.service";
import User from "../../services/user.service";
import ProgressPrompt from "./progressPrompt/progress-prompt-index";
import Helpers from "../../helpers/shared.helper";
// import HTTP from "../../services/http.service";

const subscriptions = [];
const Footer = (props) => {
  const [translationsKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {});
  const [openModal, setOpenModal] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [internalRedirectUrl, setInternalRedirectUrl] = useState("");
  
  useEffect(() => {
    
    subscriptions.push(
      Translations.getKeysObsrv().subscribe(data => {
        setTranslationsKeys(data);
      })
    )

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    }
  }, []);

  const languageConvertLink = (link) => {
    if (link && link.includes("%lang%")) {
      return link.replace("%lang%", Translations.activeLang);
    } else {
      return "#";
    }
  }

  const singleLink = (link) => {
    if (link) {
      return link;
    } else {
      return "#";
    }
  }

  const handleProtection = () => {
    localStorage.setItem("protection_channel_redirect", true);
    localStorage.setItem("protection_channel_redirect_url", Settings?.quick_links?.protection_channel);
    localStorage.setItem("protection_channel_step", true);
  }

  const handleSimDeactivation = () => {
    User.clear();
    Storage.clear("session");
    localStorage.clear();
    localStorage.removeItem("session")
    Storage.set("featureLoading", true);
    Storage.set("is_web_category_selected", true, true);
    Storage.set("choose_sim_deactivation", true, true);
    window.location.href = "/join/";
  }

  const handleBillPayment = () => {
    User.clear();
    Storage.clear("session");
    localStorage.clear();
    Storage.set("featureLoading", true);
    localStorage.setItem("choose_bill_payment", true);
    User.fetchFlowStatus();
    window.location.href = "/join/";
  }

  const staticLanguageLink = (link, linkAR) => {
    if (Translations.activeLang === "en") {
      return link;
    }
    if (Translations.activeLang === "ar") {
      return linkAR;
    }
    return "#";
  };

  const handleModal = (e) => {
    setOpenModal((prev) => !prev);
  };

  const handleYes = () => {
    if(internalRedirectUrl) {
      setRedirectUrl("");
      switch (internalRedirectUrl) {
        case "billPayment":
          handleBillPayment();
          break;
        case "protectionChannel":
          handleProtection();
          window.location.href = staticLanguageLink(Settings.footer?.protection_channel, Settings.footer?.protection_channel)
          break;
        case "simDeactivation":
          handleSimDeactivation();
          // window.location.href = singleLink(Settings?.footer?.sim_deactivation);
          break;
        default:
          break;
      }
    } else {
      if(redirectUrl) {
        setInternalRedirectUrl("");
        window.location.href = redirectUrl;
      }
    }
    setOpenModal((prev) => !prev);
    // window.open(redirectUrl, '_blank'); // Open the internal route in a new tab
  }

  const handleLinkClick = (event) => {
    setInternalRedirectUrl("");
    event.preventDefault(); // Prevent the default link behavior
    const url = event.currentTarget.getAttribute("href");
    setRedirectUrl(url);
    setOpenModal((prev) => !prev);
  };

  const handleInternalClick = (type) => {
    setRedirectUrl("");
    setInternalRedirectUrl(type);
    setOpenModal((prev) => !prev);
  }

  return (
  <>
    <div className="footer-container-ob">
      <div>
        <div className="footer-social-ob">
          <div className="stay-connected-ob">
            <span>{translationsKeys["stm_footer_stay_connected"]}</span>
            <ul>
              <li>
                <a href={singleLink(Settings?.social_links?.facebook)} onClick={handleLinkClick} target="_blank" rel="noopener noreferrer">
                  <img src={Facebook} alt="Facebook" />
                </a>
              </li>
              <li>
                <a href={singleLink(Settings?.social_links?.instagram)} onClick={handleLinkClick} target="_blank" rel="noopener noreferrer">
                  <img src={Insta} alt="Instagram" />
                </a>
              </li>
              <li>
                <a href={singleLink(Settings?.social_links?.twitter)} onClick={handleLinkClick} target="_blank" rel="noopener noreferrer">
                  <img src={Tiwiter} alt="Twitter" />
                </a>
              </li>
              {/* <li>
                                <a href={singleLink(Settings?.social_links?.linkdin)} target="_blank" rel="noopener noreferrer">
                                    <img src={LinkedIN} alt="Linkedin" />
                                </a>
                            </li> */}
              <li>
                <a href={singleLink(Settings?.social_links?.youtube)} onClick={handleLinkClick} target="_blank" rel="noopener noreferrer">
                  <img src={YouTube} alt="YouTube" />
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-cta-container">
            <a href={`tel:+${Settings?.call_us}`} onClick={handleLinkClick}>
              <div className="footer-box-cta">
                <div>
                  <img src={CallUs} alt={translationsKeys["stm_footer_call_us"]} />
                </div>
                <div>
                  <div>{translationsKeys["stm_footer_call_us"]}</div>
                  <div>{Settings?.call_us}</div>
                </div>
              </div>
            </a>
            <a href={languageConvertLink(Settings?.footer?.get_map_stores)} onClick={handleLinkClick} target="_blank" rel="noopener noreferrer">
              <div className="footer-box-cta">
                <div>
                  <img src={LocateUs} alt="Locate Us" />
                </div>
                <div>
                  <div>{translationsKeys["stm_footer_locate_us"]}</div>
                  <div>{translationsKeys["stm_footer_we_are_where_you_are"]}</div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="footer-menu-ob">
          <div className="footer-accordion-ob">
            <div>
              <div>{translationsKeys["stm_footer_about_us"]}</div>
            </div>
            <ul>
              <li><a onClick={handleLinkClick} href={staticLanguageLink(Settings?.footer?.about_vmEN, Settings?.footer?.about_vmAR)} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_about_virgin_mobile"]}</a></li>
              <li><a onClick={handleLinkClick} href={singleLink(Settings?.footer?.virgin_group)} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_virgin_group"]}</a></li>
              <li><a onClick={handleLinkClick} href={singleLink(Settings?.footer?.vat_certificate)} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_vat_certificate"]}</a></li>
              <li><a onClick={handleLinkClick} href={singleLink(Settings?.footer?.customer_rights)} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_customer_rights"]}</a></li>
            </ul>
          </div>
          <div className="footer-accordion-ob">
            <div>
              <div>{translationsKeys["stm_footer_other_links"]}</div>
            </div>
            <ul>
              {Helpers.getFeatureDisabled("webSimDeactivation") ?
              <li>
                <span
                  onClick={() => {
                    handleInternalClick("simDeactivation");
                  }}
                >
                  {translationsKeys["stm_footer_sim_deactivation"]}
                </span>
              </li> : ""}
              <li><a onClick={handleLinkClick} href={singleLink(Settings?.footer?.download_app)} target="_blank" rel="noopener noreferrer" data-name="stm_footer_down_app">{translationsKeys["stm_footer_down_app"]}</a></li>
              <li><a onClick={handleLinkClick} href={staticLanguageLink(Settings?.footer?.career_pageEN, Settings?.footer?.career_pageAR)} target="_blank" rel="noopener noreferrer" data-name="stm_footer_career_page">{translationsKeys["stm_footer_career_page"]}</a></li>
              <li><a onClick={handleLinkClick} href={singleLink(Settings?.footer?.spam_and_calls)} target="_blank" rel="noopener noreferrer" data-name="stm_footer_spam_and_sms">{translationsKeys["stm_footer_spam_and_sms"]}</a></li>
              <li><a onClick={handleLinkClick} href={staticLanguageLink(Settings?.footer?.security_awareness, Settings?.footer?.security_awarenessAR)} target="_blank" rel="noopener noreferrer" data-name="Security Awareness">{translationsKeys["stm_footer_security_awareness"]}</a></li>
              <li><a onClick={handleLinkClick} href={staticLanguageLink(Settings?.footer?.our_cookies_policy, Settings?.footer?.our_cookies_policyAR)} target="_blank" rel="noopener noreferrer" data-name="Cookies Policy">{translationsKeys["stm_footer_our_cookies_policy"]}</a></li>
              <li><a onClick={handleLinkClick} href={staticLanguageLink(Settings?.footer?.child_protection, Settings?.footer?.child_protectionAR)} target="_blank" rel="noopener noreferrer" data-name="Child Protection">{translationsKeys["stm_footer_child_protection"]}</a></li>
              {Helpers.getFeatureDisabled("webBillPayment") ? <li>
              <span
                onClick={() => {
                  handleInternalClick("billPayment");
                }}
              >
                {translationsKeys["stm_footer_bill_payment"]}
              </span>
            </li> : ""}
            </ul>
          </div>
          <div className="footer-accordion-ob">
            <div>
              <div>{translationsKeys["stm_footer_help_and_support"]}</div>
            </div>
            <ul>
              <li><a onClick={handleLinkClick} href={staticLanguageLink(Settings?.footer?.faqs, Settings?.footer?.faqsAR)} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_faqs"]}</a></li>
              <li><a onClick={handleLinkClick} href={staticLanguageLink(Settings?.footer?.contact_us, Settings?.footer?.contact_usAr)} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_contact_us"]}</a></li>
              <li><a onClick={handleLinkClick} href={languageConvertLink(Settings?.footer?.get_map_stores)} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_find_store"]}</a></li>
              {Helpers.getFeatureDisabled("webProtectionChannel") ? <li>
                <span
                  onClick={() => {
                    handleInternalClick("protectionChannel");
                  }}
                  >
                  {translationsKeys["stm_footer_protection_channel"]}
                </span>
              </li> : ""}
            </ul>
          </div>
          {/* <div className="footer-subscribtion-ob">
                        <div>{translationsKeys["stm_footer_sign_up"]}</div>
                        <div>{translationsKeys["stm_footer_signup_and_get_latest_news"]}</div>
                    </div> */}
        </div>
        <div className="footer-copy-container-ob">
          <div>
            <img src={VMLogo} alt="logo" className="footer-logo-desktop" />
            <span>{translationsKeys["stm_footer_virgin_ksa_all_rights_reserved"]}</span>
          </div>
          <ul>
            <li><a onClick={handleLinkClick} href={staticLanguageLink(Settings?.footer?.privacy, Settings?.footer?.privacyAR)} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_privacy"]}</a></li>
            <li><a onClick={handleLinkClick} href={staticLanguageLink(Settings?.footer?.terms_and_conditions, Settings?.footer?.terms_and_conditionsAR)} target="_blank" rel="noopener noreferrer">{translationsKeys["stm_footer_terms_and_condition"]}</a></li>
          </ul>
        </div>
      </div>
    </div>
    <ProgressPrompt handleModal={handleModal} openModal={openModal} handleYes={handleYes}/>
    </>
  );
};

export default Footer;